/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_COMMITTE_INVITE_STATUS, GET_PURCHASE_COUNT } from "../graphql";
import { VApplication } from "../../../application";
import config from "../config/appCardWidget.config.json";
import { templateReplacer } from "../../../helpers/template.replace";
import { pretty } from "@vlinder-web/utils-react";
import config1 from "../config/useremail.config.json";
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IMyCommitteInviteStatusMethods extends IPluginMethodMap {
  getMyCommitteInviteStatusProps(args: any): Promise<any>;
}

export class MyCommitteInviteStatusService implements IAgentPlugin {
  readonly methods: IMyCommitteInviteStatusMethods;

  constructor() {
    this.methods = {
      getMyCommitteInviteStatusProps:
        this.getMyCommitteInviteStatusProps.bind(this),
    };
  }

  async getMyCommitteInviteStatusProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_COMMITTE_INVITE_STATUS,
          variables: {
            filter: {
              userEmail: config1?.userEmail,
              inviteType: {
                eq: "Open",
              },
            },
          },

          fetchPolicy: "network-only",
        });

        if (res?.data) {
          try {
            if (client) {
              const res1 = await client.query({
                query: GET_PURCHASE_COUNT,
                variables: {
                  filter: {
                    email: config1?.userEmail,
                  },
                },

                fetchPolicy: "network-only",
              });
              console.log("Response for 2nd call in graphql====", res1);
              const _res = res?.data;
              let payload = res?.data?.getAllCommitteInviteStatus;
              let sumMaxInvites = 0;
              let sumInviteUsed = 0;
              let purchasedCount = this.formatInviteCount(
                res1?.data?.getBoxCountsForCommitteMember?.data
              );

              const contentArray = payload?.content;
              for (const obj of contentArray) {
                console.log("max invite====", obj);
                if (obj.maxInvites) {
                  sumMaxInvites += obj?.maxInvites ?? 0;
                }
                if (obj.referalsUsed) {
                  sumInviteUsed += obj?.referalsUsed ?? 0;
                }
                // if (obj.purchased) {
                //   purchasedCount += obj?.purchased ?? 0;
                // }
              }
              const rem =
                sumMaxInvites - sumInviteUsed > 0
                  ? sumMaxInvites - sumInviteUsed
                  : 0;

              const not_purchased =
                sumInviteUsed - purchasedCount > 0
                  ? sumInviteUsed - purchasedCount
                  : 0;
              const result = this.getTransformConfig(
                config,
                sumMaxInvites,
                sumInviteUsed,
                purchasedCount,
                not_purchased,
                rem
              );
              console.log("result==>", pretty(result))
              return {
                appCard: result,
              };
            }
          } catch (err: any) {
            let _display_message =
              err?.graphQLErrors &&
              Array.isArray(err?.graphQLErrors) &&
              err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
              throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
          }
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatInviteCount(purchaseArray?: any) {
    let totalCount = 0;
    for (let i = 0; i < purchaseArray.length; i++) {
      totalCount = totalCount + purchaseArray[i]?.count;
      console.log("count===", purchaseArray[i]);
    }
    return totalCount;
  }

  private getTransformConfig(
    data: any,
    maxCount: any,
    usedInvite: any,
    purchased: any,
    not_purchased: any,
    remaining: any
  ) {
    console.log("purchase method==>", purchased, not_purchased);
    const _transConfig = templateReplacer(JSON.stringify(data), {
      maxInvite: maxCount,
      inviteUsed: usedInvite,
      remaining: remaining,
      purchased: purchased,
      not_purchased: not_purchased,
    });
    return JSON.parse(_transConfig);
  }
}
